export default {"src":"/planos/_next/static/media/equifax-arrow-down.37a5b4af.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};